export const isMobileDevice = function() {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
};
